'use client';

import { Cookie } from 'lucide-react';
import Link from 'next/link';

import { LEGAL_ROUTES } from '@/common/constants';
import { acknowledgeCookies, useCookieAcknowledged } from '@/components/cookie-ack';
import { Button } from '@/components/ui/button';

export function CookieNotice() {
  const acknowledged = useCookieAcknowledged();
  if (acknowledged) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-md rounded-xl border border-border bg-background p-3 shadow-xl motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-4 sm:inset-x-auto sm:bottom-4 sm:left-4 sm:p-5"
    >
      <div className="flex items-start gap-3">
        <div
          aria-hidden
          className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-muted text-foreground"
        >
          <Cookie size={16} />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-foreground">We use cookies</p>
          <p className="text-sm text-muted-foreground">
            We use cookies and similar technologies to make this site work, understand how it&apos;s
            used, and improve it. See our{' '}
            <Link
              href={LEGAL_ROUTES.cookieNotice}
              className="underline underline-offset-2 hover:text-foreground"
            >
              Cookie Notice
            </Link>
            .
          </p>
        </div>
      </div>
      <Button onClick={acknowledgeCookies} size="sm" className="mt-4 w-full">
        I understand
      </Button>
    </div>
  );
}
